import { db } from '../db';

import { Store } from '../store';

const addTranslation = async (txt) => {
  await db.from('translations')
    .insert({
      rs: txt,
      de: '',
      fr: '',
      it: '',
    });
}

export const translate = (txt) => {
  // TODO: Uncoment to add translations to database
  //addTranslation(txt).catch(() => { });

  const nav = Store.nav;

  if (nav.translations && nav.translations[txt] && nav.translations[txt][nav.lang]) {
    return nav.translations[txt][nav.lang];
  }

  return txt;
}
